module.exports = __webpack_public_path__ + "media/images/footer-pattern-b47139fc.svg";